import { useState } from 'react';

const useCommonModal = ({ onClose = () => {}, onOpen = () => {}, initialState = false } = {}) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const handleOpenModal = () => {
    setIsOpen(true);
    onOpen?.();
  };
  const handleCloseModal = () => {
    setIsOpen(false);
    onClose?.();
  };

  const toggleModal = () => {
    setIsOpen((prevState) => !prevState);
  };

  return { isOpen, handleOpenModal, handleCloseModal, toggleModal };
};

export default useCommonModal;
